import { CardDescription } from '@/components/ui/card';
import { useTranslation } from 'react-i18next';

type AuthType = 'signup' | 'login' | 'verify' | 'resetPassword';

interface AuthDescriptionProps {
  type: AuthType;
  organizationName?: string;
}

export function AuthDescription({
  type,
  organizationName,
}: AuthDescriptionProps) {
  const { t } = useTranslation();

  return (
    <CardDescription className="text-center">
      {organizationName && (
        <>
          <span className="text-primary font-medium">
            {t('auth.layout.joinOrganization', {
              organizationName,
            })}
          </span>
          <br />
        </>
      )}
      <span className={organizationName ? 'text-muted-foreground' : ''}>
        {t(`auth.${type}.description`)}
      </span>
    </CardDescription>
  );
}
